module.exports = __webpack_public_path__ + "static/media/pecas.7bae9e02.svg";